const KEY_LEVEL = 'cblix2.level';
const KEY_MUTED = 'cblix2.muted';
const KEY_SEED = 'cblix2.seed';

const safe = (fn: () => void): void => {
  try {
    fn();
  } catch {
    /* localStorage may be blocked */
  }
};

export const loadLevel = (): number => {
  try {
    const v = parseInt(localStorage.getItem(KEY_LEVEL) ?? '1', 10);
    return Number.isFinite(v) && v > 0 ? v : 1;
  } catch {
    return 1;
  }
};

export const saveLevel = (level: number): void =>
  safe(() => localStorage.setItem(KEY_LEVEL, String(level)));

export const loadMuted = (): boolean => {
  try {
    return localStorage.getItem(KEY_MUTED) === '1';
  } catch {
    return false;
  }
};

export const saveMuted = (m: boolean): void =>
  safe(() => localStorage.setItem(KEY_MUTED, m ? '1' : '0'));

export const loadSeed = (): number => {
  try {
    const v = parseInt(localStorage.getItem(KEY_SEED) ?? '0', 10);
    if (Number.isFinite(v) && v > 0) return v;
  } catch {
    /* fallthrough */
  }
  const next = Math.floor(Math.random() * 1_000_000_000) + 1;
  safe(() => localStorage.setItem(KEY_SEED, String(next)));
  return next;
};

export const newSeed = (): number => {
  const next = Math.floor(Math.random() * 1_000_000_000) + 1;
  safe(() => localStorage.setItem(KEY_SEED, String(next)));
  return next;
};
